import Vue from 'vue'
import Vuex from 'vuex'
import init from "@/store/modules/init"
import login from "@/store/modules/login"
import user from "@/store/modules/user"
import community from './modules/community'
import cloudgame from './modules/cloudgame'
import popup from "@/store/modules/popup"
import activity from './modules/activity'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isApp: localStorage.getItem('isUniApp') || false,
    statusBarHeight: Number(localStorage.getItem('statusBarHeight')) || 0,
    appDeviceInfo: JSON.parse(localStorage.getItem('appDeviceInfo')) || {},
    isFullScreen: true,
    isEmbedded: false, // 是否内嵌webview
  },
  getters: {
  },
  mutations: {
    setIsEmbedded(state, payload) {
      state.isEmbedded = payload
    },
    setIsFullScreen(state, payload) {
      state.isFullScreen = payload
    },
    setDeviceInfo(state, payload) {
      state.appDeviceInfo = payload
      localStorage.setItem('appDeviceInfo', JSON.stringify(payload))
    },
    setIsApp(state, payload) {
      state.isApp = payload
      localStorage.setItem('isUniApp', payload)
    },
    setStatusBarHeight(state, payload) {
      state.statusBarHeight = payload
      localStorage.setItem('statusBarHeight', payload)
    }
  },
  actions: {
  },
  modules: {
    init,
    login,
    user,
    popup,
    community,
    cloudgame,
    activity
  }
})
